// Imports
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { t } from "i18next";
import { formatDate } from "util/datelib";
import MoreAction, { DropDownItem } from "widgets/controls/moreAction";

// Define the structure of the JdTableModel
export class AuditTrailPageTableModel {
  account: string;
  action: string;
  cognito_username: string;
  created: string;
  meta: {
    snr: string;
    specifics: any[];
  };
  reference: string;
  snr: string;
  username: string;
  actions: string;
}
const defineAtTablecolumns = (
  onViewClick?: (info: CellContext<AuditTrailPageTableModel, any>) => void
) => {
  // Initialize the translation hook and
  const moreMenuItems: DropDownItem[] = [
    {
      label: t("button.action.view"),
      active: true,
      onSelected: onViewClick,
    },
  ];

  // create a column helper for the JdTableModel
  const columnHelper = createColumnHelper<AuditTrailPageTableModel>();

  // Define the columns for the JdTable
  const auditTrailPageTablecolumns = [
    // Reference column
    columnHelper.accessor("snr", {
      enableSorting: false,
      meta: { rowClick: false },
      header: () => <span className="">{t("table.header.device.snr")}</span>,
      cell: (info) => <span className="">{info.getValue()}</span>,
    }),

    columnHelper.accessor("username", {
      enableSorting: false,
      meta: { rowClick: false },
      header: () => <span className="">{t("table.header.username")}</span>,
      cell: (info) => <span className="">{info.getValue()}</span>,
    }),

    columnHelper.accessor("action", {
      enableSorting: false,
      meta: { rowClick: false },
      header: () => <span className="">{t("table.header.action")}</span>,
      cell: (info) => <span className="">{info.getValue()}</span>,
    }),

    columnHelper.accessor("created", {
      enableSorting: true,
      meta: { rowClick: false },
      header: () => <span className="">{t("table.header.created")}</span>,
      cell: (info) => (
        <span className="">{formatDate(info.getValue(), "lastcomms")}</span>
      ),
    }),

    columnHelper.accessor("reference", {
      enableSorting: false,
      meta: { rowClick: false },
      header: () => <span className="">{t("table.header.reference")}</span>,
      cell: (info) => <span className="">{info.getValue().toUpperCase()}</span>,
    }),

    // Actions column
    columnHelper.accessor("actions", {
      enableSorting: false,
      meta: {
        customClass: "justify-items-center",
        customHeadClass: "justify-items-end",
      },
      header: () => <span className="">{t("table.header.actions")}</span>,
      cell: (info) => (
        <div>
          <MoreAction
            items={moreMenuItems}
            info={info}
            title={t("button.action.audit.options")}
            extra="w-full flex"
          />
        </div>
      ),
    }),
  ];

  return auditTrailPageTablecolumns;
};

export default defineAtTablecolumns;
